import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AgentSocialsService } from "@/services/agent/AgentSocialsService";

export const useToggleAgentNotificationChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      agentId,
      channelType,
      enabled,
      channelId,
    }: {
      agentId: string;
      channelType: string;
      enabled: boolean;
      channelId?: string;
    }) => AgentSocialsService.toggleNotificationChannel(agentId, channelType, enabled, channelId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["user-agents"] });
      queryClient.invalidateQueries({ queryKey: ["agent", variables.agentId] });
    },
  });
};
